export const CHALLENGE_STATS_DAYS_REQUEST = "CHALLENGE_STATS_DAYS_REQUEST"
export const CHALLENGE_STATS_DAYS_CLEAR = "CHALLENGE_STATS_DAYS_CLEAR"
export const CHALLENGE_STATS_DAYS_SUCCESS = "CHALLENGE_STATS_DAYS_SUCCESS"
export const CHALLENGE_STATS_DAYS_ERROR = "CHALLENGE_STATS_DAYS_ERROR"
